module.exports = __webpack_public_path__ + "static/img/zj-sh2.54890923.png";